<span class="relative flex flex-col w-full h-full">
    <div class="p-8 pb-2 mb-0" mat-dialog-title>
        <div class="flex items-center justify-between gap-3 border-b pb-[10px] min-w-0">
            <div class="min-w-0 flex-1">
                <div class="text-2xl sm:text-4xl font-bold leading-tight truncate">Ítarupplýsingar skjals</div>
            </div>

            <button type="button" (click)="close()" mat-icon-button [matTooltip]="'Loka'" class="shrink-0">
                <mat-icon class="text-secondary" [svgIcon]="'heroicons_outline:x'"></mat-icon>
            </button>
        </div>
    </div>
    <div class="p-8 pt-0 pb-0" mat-dialog-content>
        <ng-container>
            <div class="inset-0 static inset-auto flex flex-col">
                <!-- Content -->
                <span id="view-file-content"
                    class="relative flex flex-col flex-auto max-h-120 divide-y overflow-y-auto bg-card overflow-hidden mb-1">
                    <div class="p-3 flex flex-row flex-wrap">
                        <div class="flex flex-row flex-wrap -mx-6 pr-4">
                            <div class="flex flex-col mx-6 my-3">
                                <div class="text-sm font-medium leading-none text-secondary">Skjalanúmer</div>
                                <div class="mt-2 font-medium text-2xl leading-none">{{data.document?.documentId}}</div>
                            </div>
                        </div>
                        <div class="flex flex-row flex-wrap -mx-6 pr-4">
                            <div class="flex flex-col mx-6 my-3">
                                <div class="text-sm font-medium leading-none text-secondary">Kennitala eiganda /
                                    viðtakanda</div>
                                <div class="mt-2 font-medium text-2xl leading-none">
                                    {{formatKennitala(data.document.ssn)}}</div>
                            </div>
                        </div>
                        <div class="flex flex-row flex-wrap -mx-6 pr-4">
                            <div class="flex flex-col mx-6 my-3">
                                <div class="text-sm font-medium leading-none text-secondary">Titill</div>
                                <div class="mt-2 font-medium text-2xl leading-none">{{data.document?.title}}</div>
                            </div>
                        </div>
                        @if (data.document.typeTitle) {
                        <div class="flex flex-row flex-wrap -mx-6 pr-4">
                            <div class="flex flex-col mx-6 my-3">
                                <div class="text-sm font-medium leading-none text-secondary">Tegund</div>
                                <div class="mt-2 font-medium text-2xl leading-none">{{data.document.typeTitle}}</div>
                            </div>
                        </div>
                        } @if (data.document.systemTitle) {
                        <div class="flex flex-row flex-wrap -mx-6 pr-4">
                            <div class="flex flex-col mx-6 my-3">
                                <div class="text-sm font-medium leading-none text-secondary">Kerfi</div>
                                <div class="mt-2 font-medium text-2xl leading-none">{{data.document.systemTitle}}</div>
                            </div>
                        </div>
                        } @if (data.document.categoryTitle) {
                        <div class="flex flex-row flex-wrap -mx-6 pr-4">
                            <div class="flex flex-col mx-6 my-3">
                                <div class="text-sm font-medium leading-none text-secondary">Flokkur</div>
                                <div class="mt-2 font-medium text-2xl leading-none">{{data.document.categoryTitle}}
                                </div>
                            </div>
                        </div>
                        } @if (data.document.subcategoryTitle) {
                        <div class="flex flex-row flex-wrap -mx-6 pr-4">
                            <div class="flex flex-col mx-6 my-3">
                                <div class="text-sm font-medium leading-none text-secondary">Undirflokkur</div>
                                <div class="mt-2 font-medium text-2xl leading-none">{{data.document.subcategoryTitle}}
                                </div>
                            </div>
                        </div>
                        }
                        <div class="flex flex-row flex-wrap -mx-6 pr-4">
                            <div class="flex flex-col mx-6 my-3">
                                <div class="text-sm font-medium leading-none text-secondary">Dagsetning skjals</div>
                                <div class="mt-2 font-medium text-2xl leading-none">{{data.document.documentDate |
                                    date:'dd.MM.yyyy'}}</div>
                            </div>
                        </div>
                        <div class="flex flex-row flex-wrap -mx-6 pr-4">
                            <div class="flex flex-col mx-6 my-3">
                                <div class="text-sm font-medium leading-none text-secondary">Útgáfudagsetning</div>
                                <div class="mt-2 font-medium text-2xl leading-none">
                                    {{data.document.publicationDate | date:'dd.MM.yyyy'}}
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-row flex-wrap -mx-6 pr-4">
                            <div class="flex flex-col mx-6 my-3">
                                <div class="text-sm font-medium leading-none text-secondary">Ísland.is</div>
                                <div class="mt-2 font-medium text-2xl leading-none">
                                    {{data.document?.stafraentIslandId ? 'Já' : 'Nei' }}
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-row flex-wrap -mx-6 pr-4">
                            <div class="flex flex-col mx-6 my-3">
                                <div class="text-sm font-medium leading-none text-secondary">Mínar síður</div>
                                <div class="mt-2 font-medium text-2xl leading-none">
                                    {{data.document?.internalDoc ? 'Nei' : 'Já' }}
                                </div>
                            </div>
                        </div>
                        @if (data.document?.description?.length > 0) {
                        <div class="flex flex-row flex-wrap -mx-6 pr-4">
                            <div class="flex flex-col mx-6 my-3">
                                <div class="text-sm font-medium leading-none text-secondary">Lýsing</div>
                                <div class="mt-2 leading-none" [innerHTML]="data.document?.description"></div>
                            </div>
                        </div>
                        }
                        <div class="inline w-100">
                            <div class="flex flex-col text-xs">
                                <div class="mt-2 mb-1 border-t"></div>
                                @if (canPerformActions) { @if (!data.document?.stafraentIslandId) {
                                <div class="c-link float-left" (click)="submitToDigitalIceland()">
                                    <i class="fa-solid fa-file-circle-minus text-primary mr-[5px] inline"></i>
                                    <span class="inline">Senda á Ísland.is</span>
                                </div>
                                } @if (data.document?.stafraentIslandId) {
                                <div class="c-link float-left" (click)="withdrawDocument(false)">
                                    <i class="fa-solid fa-file-circle-minus text-primary mr-[5px] inline"></i>
                                    <span class="inline">Eyða skjali (Ísland.is)</span>
                                </div>
                                } @if (data.document?.internalDoc) {
                                <div class="c-link float-left" (click)="submitToPortalLSR()">
                                    <i class="fa-solid fa-file-circle-minus text-primary mr-[5px] inline"></i>
                                    <span class="inline">Senda skjal á Mínar síður LSR</span>
                                </div>
                                } @if (!data.document?.internalDoc) {
                                <div class="c-link float-left" (click)="withdrawDocument(true)">
                                    <i class="fa-solid fa-file-circle-minus text-primary mr-[5px] inline"></i>
                                    <span class="inline">Eyða skjali (Mínar síður LSR)</span>
                                </div>
                                }
                                <div class="c-link float-left" (click)="removeDocument()">
                                    <i class="fa-solid fa-file-circle-minus text-primary mr-[5px] inline"></i>
                                    <span class="inline">Eyða skjali (Ísland.is, Mínar síður LSR, Snjallari LSR)</span>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </span>
                <button class="w-[100%] mb-6" mat-flat-button [color]="'primary'"
                    (click)="handleGetDocument(data.document)">
                    <mat-icon [svgIcon]="'heroicons_outline:document-download'"></mat-icon>
                    <span class="ml-2 mr-1 block">Sækja skjal</span>
                </button>
            </div>
        </ng-container>
    </div>
</span>